module.exports = __webpack_public_path__ + "static/media/Nairabet Logo.3a4f47d6.svg";